module.exports = __webpack_public_path__ + "img/default-image.8a90dba4.jpg";